import React, { useState } from 'react';

const BonificoPagamento = ({ orderData, onSuccess, onError }) => {
    const [isConfirmed, setIsConfirmed] = useState(false);
    
    // Dati bancari (inserisci i tuoi)
    const bankDetails = {
        nomeBanca: 'Banca Intesa Sanpaolo',
        intestatario: 'La Tua Azienda SRL',
        iban: 'IT00X1234567890000000000000',
        bic: 'BCITITMM',
        causale: `Ordine ${orderData.numero_ordine} - ${orderData.nome_cliente || 'Cliente'}`
    };
    
    const handleConfirm = () => {
        setIsConfirmed(true);
        if (onSuccess) {
            onSuccess({
                metodo: 'bonifico',
                stato: 'in_attesa',
                data: new Date().toISOString(),
                ...bankDetails
            });
        }
    };
    
    return (
        <div className="bonifico-container">
            <div className="bonifico-info">
                <h4>🏦 Dati per Bonifico Bancario</h4>
                <p>Effettua il bonifico utilizzando i seguenti dati:</p>
                
                <div className="bank-details">
                    <div className="bank-row">
                        <span className="bank-label">Banca:</span>
                        <span className="bank-value">{bankDetails.nomeBanca}</span>
                    </div>
                    <div className="bank-row">
                        <span className="bank-label">Intestatario:</span>
                        <span className="bank-value">{bankDetails.intestatario}</span>
                    </div>
                    <div className="bank-row">
                        <span className="bank-label">IBAN:</span>
                        <span className="bank-value highlight">{bankDetails.iban}</span>
                    </div>
                    <div className="bank-row">
                        <span className="bank-label">BIC/SWIFT:</span>
                        <span className="bank-value">{bankDetails.bic}</span>
                    </div>
                    <div className="bank-row">
                        <span className="bank-label">Causale:</span>
                        <span className="bank-value">{bankDetails.causale}</span>
                    </div>
                </div>
                
                <div className="bonifico-warning">
                    <span>⚠️</span>
                    <div>
                        <strong>Importante:</strong>
                        <ul>
                            <li>Inserisci il numero ordine nella causale</li>
                            <li>L'ordine sarà evaso dopo la ricezione del pagamento</li>
                            <li>Riceverai una email di conferma</li>
                        </ul>
                    </div>
                </div>
                
                {!isConfirmed ? (
                    <button className="confirm-btn" onClick={handleConfirm}>
                        📧 Ho effettuato il bonifico
                    </button>
                ) : (
                    <div className="confirmation-message">
                        ✅ Grazie! Riceverai una email di conferma.
                        <br />
                        <small>L'ordine sarà spedito non appena riceviamo il pagamento.</small>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BonificoPagamento;
